import { useCallback, useState } from 'react';

import { adminLocalizationKeys } from '@/api';
import { ConstructorApi } from '@/features/constructorProducts/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useProductDescription = () => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreate = useCallback(async (product) => {
    try {
      setIsCreating(true);
      const result = await ConstructorApi.addProductDescription(product);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllProducts]
        });
        showSuccessToast('Created description section');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  const handleUpdate = useCallback(async (description) => {
    try {
      setIsUpdating(true);
      const result = await ConstructorApi.changeProductDescription(description);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllProducts]
        });
        showSuccessToast('Saved');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const handleDelete = useCallback(async (productDescriptionId) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteProductDescription(productDescriptionId);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllProducts]
        });
        showSuccessToast('Deleted');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  };
};
